// context/MessagesContext.jsx
import React, { createContext, useState, useContext } from 'react';
import { messageAPI } from '../services/api';

const MessagesContext = createContext({});

export const useMessages = () => useContext(MessagesContext);

export const MessagesProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchMessages = async (params = {}) => {
    setLoading(true);
    try {
      const result = await messageAPI.getMessages(params);
      if (result.success) {
        setMessages(result.data.messages || []);
      }
      return result;
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const result = await messageAPI.getMessageStats();
      if (result.success) {
        setStats(result.data);
      }
      return result;
    } catch (error) {

      return { success: false, error: error.message };
    }
  };

  const createMessage = async (messageData) => {
    try {
      return await messageAPI.createMessage(messageData);
    } catch (error) {
  
      return { success: false, error: error.message };
    }
  };

  const markAsRead = async (id) => {
    try {
      return await messageAPI.markAsRead(id);
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const replyToMessage = async (id, replyMessage) => {
    try {
      return await messageAPI.replyToMessage(id, replyMessage);
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const deleteMessage = async (id) => {
    try {
      const result = await messageAPI.deleteMessage(id);
      if (result.success) {
        setMessages(messages.filter(msg => msg.id !== id));
      }
      return result;
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const value = {
    messages,
    stats,
    loading,
    fetchMessages,
    fetchStats,
    createMessage,
    markAsRead,
    replyToMessage,
    deleteMessage,
  };

  return (
    <MessagesContext.Provider value={value}>
      {children}
    </MessagesContext.Provider>
  );
};